import { useContext, useEffect } from 'react';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import config from 'theme/config';

export const useDefaultCurrency = () => {
  const userContext = useContext(UserContext);
  useEffect(() => {
    const currencyParam = new URLSearchParams(window.location.search).get(config.settings.currencyCodeIdentifier);
    //only use the default currency if there is no currency param and user.currency is undefined
    if (!userContext.user.currency && !currencyParam) {
      userContext.setCurrency(config.settings.defaultCurrency);
    }
  }, [userContext, userContext.user.currency]);
};
